import type { ReactNode } from 'react'
import styles from './auth.module.css'

/**
 * Branded frame shared by every auth page (sign-in, sign-up, forgot /
 * reset password). Renders the centered card, the Tinkerspace wordmark,
 * and a heading + optional subtitle above whatever form the page passes
 * as children. Presentational only — no client hooks — so it drops into
 * the `'use client'` pages without pulling extra JS.
 */
export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string
  subtitle?: ReactNode
  children: ReactNode
  footer?: ReactNode
}) {
  return (
    <main className={styles.page}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <img
            src="/logos/tinkerspace-icon-transparent.svg"
            alt=""
            width={34}
            height={34}
            className={styles.brandMark}
          />
          <span className={styles.wordmark}>
            Tinker<span className={styles.wordmarkAccent}>space</span>
          </span>
        </div>
        <h1 className={styles.title}>{title}</h1>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        {children}
        {footer}
      </div>
    </main>
  )
}

export { styles as authStyles }
